<template>
	<div class="full" style="position: relative;" id="outamountIndexChart"></div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	import * as echarts from 'echarts';
	export default {
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				chart: null,

			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			createChart(outdata,indata) {
				

				let outgroup = this.$Lodash.groupBy(outdata, 'invoicetime')
				for (let i in outgroup) {
					let outamount = this.$Lodash.sumBy(outgroup[i], (item) => {
						return item.outamount ? parseFloat(item.outamount) : 0
					})
					outgroup[i] = outamount.toFixed(2)
				}
				let xdata = this.$Lodash.keys(outgroup)
				let seriesoutdata = this.$Lodash.values(outgroup)
				
				let ingroup = this.$Lodash.groupBy(indata, 'invoicetime')
				let seriesindata = []
				for (let i in ingroup) {
					let inamount = this.$Lodash.sumBy(ingroup[i], (item) => {
						return item.inamount ? parseFloat(item.inamount) : 0
					})
					ingroup[i] = inamount.toFixed(2)
				}
				console.log(ingroup)
				xdata.forEach((item)=>{
					if(ingroup[item]){
						seriesindata.push(ingroup[item])
					}else{
						seriesindata.push(0)
					}
				})

				
				
				let series = [{
					name: '销项金额',
					type: 'bar',
					label: {
						show: false,
						position: 'top'
					},
					emphasis: {
						focus: 'series'
					},
					tooltip: {
						formatter: () => {
							return '0'
						}
					},
					data: seriesoutdata
				},{
					name: '进项金额',
					type: 'bar',
					label: {
						show: false,
						position: 'top'
					},
					emphasis: {
						focus: 'series'
					},
					tooltip: {
						formatter: () => {
							return '0'
						}
					},
					data: seriesindata
				}]
				if (this.chart) {
					this.chart.clear()
				} else {
					this.chart = echarts.init(document.getElementById('outamountIndexChart'))
				}
				this.chart.setOption({
					title: {
						show:false,
						text: 'title',
						textStyle: {
							fontSize: 14
						}
					},
					series: series,
					xAxis: {
						type: 'category',
						data: xdata
					},
					yAxis: {
						type: 'value'
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					toolbox: {
						show: false,
						orient: 'vertical',
						left: 'right',
						top: 'center',
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: false
							},
							magicType: {
								show: true,
								type: ['line', 'bar', 'stack']
							},
							restore: {
								show: false
							},
							saveAsImage: {
								show: true
							}
						}
					}
				})
			},
			
			
			
			
			
			// createChart(data) {
			// 	let group = this.$Lodash.groupBy(data, 'invoicetime')
			// 	for (let i in group) {
			// 		group[i] = this.$Lodash.groupBy(group[i], 'companyname')
			// 		for (let j in group[i]) {
			// 			let outamount = this.$Lodash.sumBy(group[i][j], (item) => {
			// 				return item.outamount ? parseFloat(item.outamount) : 0
			// 			})
			// 			group[i][j] = outamount
			// 		}
			// 	}
			// 	let xdata = this.$Lodash.keys(group)
			// 	let series = []
			// 	let companys = this.$Lodash.keys(this.$Lodash.groupBy(data, 'companyname'))

			// 	companys.forEach((company) => {
			// 		let seriesdata = []
			// 		xdata.forEach((date) => {
			// 			if (group[date][company]) {
			// 				seriesdata.push(group[date][company])
			// 			} else {
			// 				seriesdata.push(0)
			// 			}
			// 		})
			// 		series.push({
			// 			name: company,
			// 			type: 'bar',
			// 			stack: 'outamount',
			// 			label: {
			// 				show: true,
			// 				position: 'top'
			// 				// formatter: (param) => {
			// 				// 	return param.value + '万'
			// 				// }
			// 			},
			// 			emphasis: {
			// 				focus: 'series'
			// 			},
			// 			tooltip: {
			// 				formatter: () => {
			// 					return '0'
			// 				}
			// 			},
			// 			data: seriesdata
			// 		})
			// 	})
			// 	// console.log(series)
			// 	// return
			// 	// console.log(group)
			// 	if (this.chart) {
			// 		this.chart.clear()
			// 	} else {
			// 		this.chart = echarts.init(document.getElementById('outamountIndexChart'))
			// 	}
			// 	// let series = [{
			// 	// 	name: '销项金额',
			// 	// 	type: 'bar',
			// 	// 	stack: 'outamount',
			// 	// 	label: {
			// 	// 		show: true,
			// 	// 		position: 'top'
			// 	// 		// formatter: (param) => {
			// 	// 		// 	return param.value + '万'
			// 	// 		// }
			// 	// 	},
			// 	// 	emphasis: {
			// 	// 		focus: 'series'
			// 	// 	},
			// 	// 	tooltip: {
			// 	// 		formatter: () => {
			// 	// 			return '0'
			// 	// 		}
			// 	// 	},
			// 	// 	data: outamountdata
			// 	// }]

			// 	this.chart.setOption({
			// 		title: {
			// 			text: 'title',
			// 			textStyle: {
			// 				fontSize: 14
			// 			}
			// 		},
			// 		series: series,
			// 		xAxis: {
			// 			type: 'category',
			// 			data: xdata
			// 		},
			// 		yAxis: {
			// 			type: 'value'
			// 		},
			// 		grid: {
			// 			left: '3%',
			// 			right: '4%',
			// 			bottom: '3%',
			// 			containLabel: true
			// 		},
			// 		tooltip: {
			// 			trigger: 'axis',
			// 			axisPointer: {
			// 				type: 'shadow'
			// 			}
			// 		},
			// 		toolbox: {
			// 			show: false,
			// 			orient: 'vertical',
			// 			left: 'right',
			// 			top: 'center',
			// 			feature: {
			// 				mark: {
			// 					show: true
			// 				},
			// 				dataView: {
			// 					show: true,
			// 					readOnly: false
			// 				},
			// 				magicType: {
			// 					show: true,
			// 					type: ['line', 'bar', 'stack']
			// 				},
			// 				restore: {
			// 					show: false
			// 				},
			// 				saveAsImage: {
			// 					show: true
			// 				}
			// 			}
			// 		}
			// 	})
			// }
		},
		components: {

		}
	}
</script>